import { attributeValue } from "func-xml";
import { applySpec } from "ramda";
import { DIALOG_RESULT_OK } from "../UI/dialog.constants";
import showHyperlinkDialog from "../UI/hyperlinkDialog";
import { showMessageBox } from "../UI/messageBox";
import { VIEW_EVENT_HYPERLINK_BOX_CLICK } from "../viewActionHandler/viewActionHandler.constants";
import viewAction from "../viewWatcher/viewAction";
import { ATTR_BINDING, ATTR_BINDING_SECONDARY } from "./view.attribute.names";
import { getNodeId } from "./viewNodeAccessors";

const PROP_BINDING = 'binding';
const PROP_BINDING_SECONDARY = 'bindingSecondary';

const hyperlinkClickProps = applySpec({
    nodeId: getNodeId,
    [PROP_BINDING]: attributeValue(ATTR_BINDING),
    [PROP_BINDING_SECONDARY]: attributeValue(ATTR_BINDING_SECONDARY),
});

export const getHyperlinkBoxClickAction = (element) => viewAction(
    VIEW_EVENT_HYPERLINK_BOX_CLICK,
    hyperlinkClickProps(element)
);

const getFields = (getNodeForNodeId, { nodeId,[PROP_BINDING]: binding, [PROP_BINDING_SECONDARY]: bindingSecondary }) => {
    const baseNode = getNodeForNodeId(nodeId);

    if (!binding) {
        throw new Error('Control is not bound to a field.');
    }

    const mainField = baseNode.selectSingle(binding);

    const secondaryField = bindingSecondary && baseNode.selectSingle(bindingSecondary);

    if (!mainField || (bindingSecondary && !secondaryField)) {
        throw new Error('Could not find field associated with this control.');
    }

    return {
        mainField,
        secondaryField,
    };
};

export const handleHyperlinkBoxClick = (getNodeForNodeId, renderView) => async ({ props }) => {
    try {
        const { mainField, secondaryField } = getFields(getNodeForNodeId, props);

         const { result, url, displayText } = await showHyperlinkDialog(mainField.value(), secondaryField?.value(), !!secondaryField);

         if (result !== DIALOG_RESULT_OK){
            return;
         }

         await mainField.setValueAsync(url);

         if (secondaryField) {
            await secondaryField.setValueAsync(displayText);
         }

         await renderView();
    } catch (e) {
        await showMessageBox('Could not edit hyperlink', e.message);
    }
};